import { buildAllRecipesSlider } from "../utils/buildAllRecipesSlider";
import { buildProgramMealSliders } from "../utils/buildProgramMealSliders";
/**
 * Creates the appropriate slider data based on the provided configuration and state,
 * either building an "All Recipes" slider or program meal sliders.
 *
 * @param BuildSlidersArgs
 * @returns BuildAllRecipesSliderReturn | BuildProgramMealSlidersReturn
 */
export const buildSliders = ({ isAnyMealSkippedForDay, moduleConfig, programMealsWithRecipes, recipeHandlerProps_One, recipeImageBaseUrl, renderAllRecipesSlider, setAssignmentId, setIsAddDisabled, setMeals, setQuantity, store, }) => {
    if (renderAllRecipesSlider) {
        return buildAllRecipesSlider({
            isAnyMealSkippedForDay,
            moduleConfig,
            programMealsWithRecipes,
            recipeAutoSelection: moduleConfig.RecipeAutoSelection,
            recipeHandlerProps_One,
            recipeImageBaseUrl,
            setAssignmentId,
            setIsAddDisabled,
            setMeals,
            setQuantity,
            store,
        });
    }
    else {
        return buildProgramMealSliders({
            isAnyMealSkippedForDay,
            moduleConfig,
            programMealsWithRecipes,
            recipeHandlerProps_One,
            recipeImageBaseUrl,
            setAssignmentId,
            setIsAddDisabled,
            setMeals,
            setQuantity,
            store,
        });
    }
};
